import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';
import React from 'react';
import PropTypes from 'prop-types';
import IconWalkingMan from '@spothero/icons/walking-man';
import {parseWalkingDuration} from 'utils/travel-distance';

const WalkingDistanceDisplay = ({
    distance,
    distanceInMiles,
    walkingDuration,
    showDuration,
}) => {
    const duration = walkingDuration
        ? parseWalkingDuration(walkingDuration)
        : null;

    const calculatedDistance = !isUndefined(distanceInMiles)
        ? distanceInMiles
        : distance / 1609;
    const distanceString =
        calculatedDistance <= 0.1
            ? `${Math.round(calculatedDistance * 5280)} ft`
            : `${calculatedDistance.toFixed(1)} mi`;

    return (
        <div className="WalkingDistanceDisplay">
            <div className="WalkingDistanceDisplay-distance">
                <IconWalkingMan />
                <p>{distanceString}</p>
            </div>
            {showDuration && !isNil(duration) && (
                <div className="WalkingDistanceDisplay-duration">
                    {duration} walk
                </div>
            )}
        </div>
    );
};

WalkingDistanceDisplay.propTypes = {
    distance: PropTypes.number,
    distanceInMiles: PropTypes.number,
    walkingDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showDuration: PropTypes.bool,
};

export default WalkingDistanceDisplay;
